import { useEffect } from "react";
const handlers = new Map();
export function emitDataEvent(evt) {
    const set = handlers.get(evt);
    if (!set)
        return;
    for (const h of set) {
        try {
            h();
        }
        catch {
            // Swallow — one bad subscriber shouldn't block the rest.
        }
    }
}
export function useDataEvent(evt, handler) {
    useEffect(() => {
        let set = handlers.get(evt);
        if (!set) {
            set = new Set();
            handlers.set(evt, set);
        }
        set.add(handler);
        return () => {
            set.delete(handler);
        };
    }, [evt, handler]);
}
